<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ counter }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Usuário</th>
          <th>Nome</th>
          <th>Função</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.username }}</td>
          <td>{{ item.name }}</td>
          <td>
            <v-btn x-small v-bind:color="colorRole(item.role)">{{item.role | formatRole}}</v-btn>
          </td>
          <td>
            <v-btn small color="primary" @click="view(item.id)">detalhes</v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    counter: 0
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/user", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.current = response.data;
          me.counter = me.current.length;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    view: function(id) {
      this.$router.push({ path: `/user/${id}` });
    },
    register: function() {
      router.push({ path: "/user/0" });
    },
    colorRole: function(status) {
      var ret = "default";
      if (status == 0) {
        ret = "success";
      } else if (status == 64) {
        ret = "warning";
      } else if (status == 128) {
        ret = "info";
      } else if (status == 255) {
        ret = "default";
      }
      return ret;
    }
  },
  filters: {
    formatRole: function(value) {
      var ret = "desconhecido";
      if (value == 0) {
        ret = "Administrador";
      } else if (value == 64) {
        ret = "Supervisor";
      } else if (value == 128) {
        ret = "Usuário";
      } else if (value == 255) {
        ret = "Convidado";
      }
      return ret;
    }
  }
};
</script>